import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

// Get flagged content with filters
export const getFlaggedContentAPI = (filters = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/moderation/flagged-content", {
                params: filters,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get flagged users
export const getFlaggedUsersAPI = (filters = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/moderation/flagged-users", {
                params: filters,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Review flagged content (approve/reject/escalate)
export const reviewFlaggedContentAPI = (flagId, decision, reason = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch(`/api/moderation/flagged-content/${flagId}/review`, {
                action: decision,
                notes: reason,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Ban user
export const banUserAPI = (userId, reason, duration = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post(`/api/moderation/users/${userId}/ban`, {
                reason,
                duration: duration === "" ? null : String(duration),
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};
export const warningUserAPI = (userId, message) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post(`/api/moderation/users/${userId}/warning`, {
                message,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Unban user
export const unbanUserAPI = (userId, reason = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post(`/api/moderation/users/${userId}/unban`, {
                reason,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get moderation statistics
export const getModerationStatsAPI = () => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/moderation/stats", {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Bulk review flagged content
export const bulkReviewFlaggedContentAPI = (flagIds, decision, reason = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch("/api/moderation/flagged-content/bulk-review", {
                flagIds,
                decision,
                reason,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get content preview for moderation
export const getContentPreviewAPI = (contentId, contentType) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get(`/api/moderation/content-preview/${contentId}`, {
                params: { contentType },
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get post reports with filters
export const getPostReportsAPI = (filters = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/moderation/post-reports", {
                params: filters,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};
export const getCommentsReportsAPI = (filters = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/moderation/comment-reports", {
                params: filters,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Update post report status
export const updatePostReportStatusAPI = (reportId, status, moderatorComment = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch(`/api/moderation/post-reports/${reportId}/status`, {
                status,
                moderatorComment,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};
export const updateCommentReportStatusAPI = (reportId, status, moderatorComment = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch(`/api/moderation/comment-reports/${reportId}/status`, {
                status,
                moderatorComment,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get  profile reports list
export const getProfileReportsAPI = (filters = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/moderation/profile-reports", {
                params: filters,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Update profile report status
export const updateProfileReportStatusAPI = (reportId, status, moderatorComment = "", banDuration = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch(`/api/moderation/profile-reports/${reportId}/status`, { status, moderatorComment, banDuration }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

//Ban user profile
export const banUserProfileAPI = (reportId, banDuration) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch(`/api/moderation/profile-reports/${reportId}/ban`, { banDuration }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get appeals with filters
export const getAppealsAPI = (filters = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/moderation/appeals", {
                params: filters,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Update appeal status
export const updateAppealStatusAPI = (appealId, status, reviewNotes = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch(`/api/moderation/appeals/${appealId}/status`, {
                status,
                reviewNotes,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Update post status (hide/restore/delete)
export const updatePostStatusAPI = (postId, status, reason = "") => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .patch(`/api/moderation/posts/${postId}/status`, {
                status,
                reason,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};
